import { Reducer } from 'redux';
import { Segment } from '~src/interfaces/segment.interface';

import { ThunkAnyAction } from '~src/services/apiMiddleware';
import { mapIdToData } from '~src/utils';
import { typesForFetchSegments } from '~src/modules/surveys/constants/actionTypes';

export interface SegmentsStateI {
  data?: Record<string, Segment>;
  error?: Record<string, string>;
  loading: boolean;
}

export function getInitialSegmentsState(): SegmentsStateI {
  return {
    loading: false,
  };
}

const segmentsReducer: Reducer<SegmentsStateI, ThunkAnyAction> = (
  state: SegmentsStateI = getInitialSegmentsState(),
  action: ThunkAnyAction,
): SegmentsStateI => {
  switch (action.type) {
    case typesForFetchSegments.Request: {
      return {
        ...state,
        loading: true,
      };
    }
    case typesForFetchSegments.Success: {
      return {
        ...state,
        loading: false,
        data: mapIdToData(action.response.data),
      };
    }
    case typesForFetchSegments.Failed: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

export default segmentsReducer;
